import axiosInstance from "../api/axiosInstance";
import { PICK_LISTS } from "../constants/API_URLs";
export interface PickListData {
  id?: string;
  party: string;
  orderNumber: string;
  date: string;
  orderAmount: string;
  lineItem: string;
  VOR: boolean;
  U: boolean;
  status: any;
  s3Key?: string;
  pdfDownloadUrl?: string;
}

export const addPickList = (data: PickListData | FormData): Promise<any> => {
  const config =
    data instanceof FormData
      ? {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      : {};

  return axiosInstance.post(PICK_LISTS, data, config);
};

export const updatePickList = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${PICK_LISTS}/${id}`, data);
};

export const getPickLists = (params: any): Promise<any> => {
  return axiosInstance.get(PICK_LISTS, { params });
};

export const getPickList = (id: any): Promise<any> => {
  return axiosInstance.get(`${PICK_LISTS}/${id}`);
};

export const deletePickList = (id: any): Promise<any> => {
  return axiosInstance.delete(`${PICK_LISTS}/${id}`);
};

export const exportExcelPickList = (params: any): Promise<any> => {
  return axiosInstance.get(`${PICK_LISTS}/export/excel`, {
    params,
    responseType: "blob",
  });
};
